import { connect } from 'react-redux';

// Components:
import Certificate from '../components/Certificate';

// Selectors:
import { getPaymentAmount } from '../../../store/payment/selectors';
import {
  getCertText,
  getCertHolder,
  getCertDesignName,
} from '../store/certificate/selectors';

const mapStateToProps = (state) => ({
  value: getPaymentAmount(state),
  holder: getCertHolder(state),
  text: getCertText(state),
  design: getCertDesignName(state),
});

export default connect(mapStateToProps)(Certificate);
